<template>
  <el-header class="header">
    <div class="right-bar">
      <ul class="toprig">
        <li>
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" @click="getWallet">
            <el-submenu index="1">
              <template slot="title">账户金额：<span class="wallet">0</span> 元</template>
              <el-menu-item index='1' @click="cashMoney = true">提现</el-menu-item>
              <el-menu-item index='2' @click="addMoney = true">充值</el-menu-item>
            </el-submenu>
          </el-menu>
        </li>
        <li class="lines">|</li>
        <li><img class="userstoryimg"/><i class="usernickname"></i></li>
        <li class="lines">|</li>
        <li><router-link to="/">退出登录</router-link></li>
      </ul>
    </div>
    <!-- 账户充值弹窗 -->
    <div class="dial-header" id="add" @click="placeOrderTopUp">
        <el-dialog :visible.sync="addMoney">
          <div>
            <div class="addTop">
              <p>账户充值</p>
              <span>充值金额</span>
              <div>
                  <span>￥</span><input type="text" class="charge">
              </div>
            </div>
            <div class="addBot">
              <button @click="showPay = true"><div @click="addMoney = false">充值</div></button>
            </div>
          </div>
        </el-dialog>
    </div>
      <!-- 账户提现弹窗 -->
    <div class="dial-header" id="cash" @click="getBankInfo">
        <el-dialog :visible.sync="cashMoney" @close="moneyCash">
          <div>
            <div class="cashTop">
              <p>账户提现</p>
              <ul>
                <li>
                  <span>银号卡号：</span>
                  <input class="cardnum">
                </li>
                  <li>
                  <span>开户行：</span>
                  <input class="bankname">
                </li>
                <li>
                  <span>户名：</span>
                  <input class="accountname">
                </li>
              </ul>
              <p class="remember">
                <el-checkbox v-model="checked" class="checked" data="">自动保存</el-checkbox>
              </p>
              <span>提现金额</span>
              <div>
                <span>￥</span><input type="text" class="money">
              </div>
            </div>
            <div class="cashBot">
              <p>当前账户余额<span class="card">0</span>元</p> 
              <el-button :plain="true"><div @click="withdraw">提现</div></el-button>
            </div>
          </div>
        </el-dialog>
    </div>
    <!-- 支付弹框 -->
    <div class="dial-header" id="pay">
      <el-dialog :visible.sync="showPay" @close="Pay">
        <div>
          <div class="top">
            <img src="../../assets/img/weixin.png">
            <span>扫码完成微信登录</span>
          </div>
          <div class="middle">
            <div>充值金额:<span class="charges"></span></div>
            <span class="payCode"></span>
          </div>
          <div class="buttom">
            <!-- <div>还有<span>50</span>秒过期</div> -->
          </div>
        </div>
      </el-dialog>
    </div>      
  </el-header>

</template>
<script>
  import axios from 'axios'
  import $ from 'jquery'
  import {delCookie,getCookie,setCookie} from '@/util/util'
  import "../../assets/js/jquery.qrcode.min.js"

  export default {
    data(){
      return {
        activeIndex: '1',
        addMoney: false,
        cashMoney: false,
        showPay: false,
        checked:false
      };
    },
    created(){
      this.getWallet();
      this.getBankInfo();
      this.getSaleUserInfo();
      this.placeOrderTopUp();
      this.withdraw();
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      // 清空账户充值弹窗
      Pay(){
        $('.charge').val("");
        $('.payCode').text("");
      },
      // 清空账户提现弹窗
      moneyCash(){
        $('.cardnum').val("");
        $('.bankname').val("");
        $('.accountname').val("");
        $('.money').val("");
        $('.remember>label>span').removeClass("is-checked");
      },
      // 查询用户账户
      getWallet:function(){
        axios.get("/scene/wallet",{
          params:{
           token:getCookie('session'),
          }
        }).then(res => {
          this.data = res.data;
          $('.wallet').text(res.data.data.wallet);
          // 获取账户余额
          setCookie('wallet',res.data.data.wallet);
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 头像和圈号
      getSaleUserInfo:function(){
        axios.get("/scene/saleUserInfo",{
          params:{
           token:getCookie('session'),
          }
        }).then(res => {
          this.data = res.data;
          var userstoryimg=res.data.data.photo;
          var img=$('.userstoryimg').attr('src',userstoryimg);
          var usernickname=res.data.data.userName;
          var nickname=$('.usernickname').text(usernickname);
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 账户提现
      getBankInfo:function(){
        axios.get("/scene/bankInfo",{
          params:{
           token:getCookie('session'),
           identity:1
          }
        }).then(res => {
          $('.card').text(getCookie('wallet'));
          this.data = res.data;
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 提交账户提现信息
      withdraw(){
        var cardnum=$('.cardnum').val();
        var bankname=$('.bankname').val();
        var accountname=$('.accountname').val();
        var money=$('.money').val();
        // 判断是否选中自动保存
        var checked=$('.remember>label');
        if(checked.hasClass('is-checked')){
          $('.remember>label').attr('data',true)
        }else{
          $('.remember>label').attr('data',false)
        }
        var save=$('.remember>label').attr("data")
        const url ='/scene/withdraw';
        var params = new URLSearchParams();
        params.append('token',getCookie('session'));
        //是否保存
        params.append('save',save);
        params.append('cardnum',cardnum);
        params.append('bankname',bankname);
        params.append('accountname',accountname);
        params.append('identity',1);
        params.append('money',money);
        this.$axios({
          method: 'post',
          url:url,
          data:params
        }).then((res)=>{
          this.data = res.data;
          if(res.data.retCode==400){
            this.$message.error(res.data.retDesc);
          }
          if(res.data.retCode==200){
            this.$message.success(res.data.retDesc);
          }
        })
      },
      // 账户充值
      placeOrderTopUp(){
        var charge=$('.charge').val();
        $('.charges').text(charge+"元");
        const url ='/scene/placeOrderTopUp';
        var params = new URLSearchParams();
        params.append('token',getCookie('session'));
        params.append('money',charge);
        this.$axios({
          method: 'post',
          url:url,
          data:params
        }).then((res)=>{
          this.data = res.data;
          $('.payCode').qrcode(res.data.data.codeUrl)
        })
      },
    }  
  }
</script>
<style scoped lang="scss">
  .el-header {
    height: 0.78rem !important;
    width: 16.33rem;
    background:rgba(255,255,255,1);
    box-shadow:0 0.04rem  0.04rem 0 rgba(124,124,124,0.19);
    padding: 0;
  }
  .right-bar{
    float: right;
    line-height: 0.78rem;
  }
    .toprig>li{
      float: left;
      font-size:0.16rem;
      font-family:STHeitiSC-Light;
      font-weight:300;
      color:rgba(48,48,48,1);
    }
    .toprig>li>img{
      display: inline-block;
      vertical-align: top;
      width:0.34rem;
      height:0.34rem;
      border-radius:50%;
      margin:0.22rem 0.09rem 0 0;
    }
    .toprig>li:last-of-type{
      margin-right: 0.42rem;
    }
    .lines{
      width:0.01rem;
      height:0.14rem;
      /*background:rgba(229,229,229,1);*/
      margin: -0.01rem 0.2rem 0 0.2rem;
    }
</style>
<style>
  .el-menu--popup-bottom-start{
    margin-top: 0;
  }
  .el-menu--popup{
    text-align: center;
    min-width: 2rem;
  }
  .header #add .el-dialog{
      width:5.6rem;
      height:4.5rem;
      background:rgba(255,255,255,1);
      border-radius:0.12rem;
    }
  .header #add .el-dialog__header{
    padding: 0;
  }
  .header #add .el-dialog__body{
    padding:0;
  }
  .header #add .el-dialog__headerbtn{
    top: 0;
    right: 0;
  }
  .header #add .el-dialog__body>div{
    padding-left: 0.45rem;
    padding-right: 0.47rem;
  }
  .header #add .addTop{
    padding-top: 0.42rem;
    border-bottom: 0.02rem solid #eee; 
  }
  .header #add .addTop>p{
    height:0.26rem;
    font-size:0.26rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
    margin-bottom: 0.88rem;
  }
  .header #add .addTop>span{
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
  }
  .header #add .addTop>div{
    margin-top:0.27rem;
  }
  .header #add .addTop>div>span{
    height:0.48rem;
    font-size:0.48rem;
    font-family:ArialMT;
    font-weight:400;
    color:rgba(79,79,79,1);
    line-height:0.48rem;
  }
  .header #add .addTop>div>input{
    width: 3rem;
    font-size:0.48rem;
    margin-left: 0.08rem;
  }
  .header #add .addBot>button{
    width:4.68rem;
    height:0.70rem;
    background:rgba(244,57,65,1);
    box-shadow:0 0.02rem 0.05rem 0.01rem rgba(145,2,2,0.36);
    border-radius:0.12rem;
    font-size:0.3rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(255,255,255,1);
    margin: 0.33rem 0 0 0;
  }
  .header #add .addBot>button>span{
    letter-spacing: 0.3rem;
    margin-left: 0.2rem;
  }

  .header #cash .el-dialog{
      width:5.66rem;
      height:6.46rem;
      background:rgba(255,255,255,1);
      border-radius:0.12rem;
    }
  .header #cash .el-dialog__header{
    padding: 0;
  }
  .header #cash .el-dialog__body{
    padding:0;
  }
  .header #cash .el-dialog__headerbtn{
    top: 0;
    right: 0;
  }
  .header #cash .el-dialog__body>div{
    padding-left: 0.51rem;
    padding-right: 0.47rem;
  }
  .header #cash .cashTop{
    padding-top: 0.47rem;
    border-bottom: 0.02rem solid #eee; 
  }
  .header #cash .cashTop>p{
    height:0.26rem;
    font-size:0.26rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
    margin-bottom: 0.5rem;
  }
  .header #cash .cashTop>ul{
    float: left;
  }
  .header #cash .cashTop>ul>li{
    width: 4.65rem;
    height:0.18rem;
    float: left;
    margin-bottom: 0.42rem;
  }
  .header #cash .cashTop>ul>li:last-of-type{
    margin-bottom: 1rem;
  }
  .header #cash .cashTop>ul>li>span{
    float: left;
    width:1rem;
    height:0.18rem;
    text-align: right;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
  }
  .header #cash .cashTop>ul>li>input{
    height:0.2rem;
    width: 3rem;
    font-size:0.2rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
  }
  .header #cash .cashTop>.remember{
    float: right;
    height:0.14rem;
    font-size:0.14rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(163,160,160,1);
    margin-top: -0.8rem;
  }
  .header #cash .cashTop>.remember>input{
    width:0.14rem;
    height:0.14rem;
    margin-right: 0.02rem;
    border:0.01rem solid rgba(210,210,210,1);
  }
  .header #cash .cashTop>span{
    height:0.24rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
  }
  .header #cash .cashTop>div{
    margin-top:0.12rem;
  }
  .header #cash .cashTop>div>span{
    height:0.48rem;
    font-size:0.48rem;
    font-family:ArialMT;
    font-weight:400;
    color:rgba(79,79,79,1);
    line-height:0.48rem;
  }
  .header #cash .cashTop>div>input{
    width: 3rem;
    font-size:0.48rem;
    margin-left: 0.08rem;
  }
  .header #cash .cashBot>p{
    height:0.14rem;
    font-size:0.14rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(163,160,160,1);
    margin: 0.11rem 0 0.38rem 0;
  }
  .header #cash .cashBot>button{
    width:4.68rem;
    height:0.60rem;
    background:rgba(244,57,65,1);
    box-shadow:0 0.02rem 0.05rem 0.01rem rgba(145,2,2,0.36);
    border-radius:0.12rem;
    font-size:0.3rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(255,255,255,1);
  }
  .header #cash .cashBot>.el-button{
    border:0;
  }
  .header #cash .cashBot>button>span{
    display: inline-block;
    letter-spacing: 0.3rem;
    margin-left: 0.2rem;
  }
  .header .el-submenu__title{
    padding: 0;
  }
  .header .el-menu.el-menu--horizontal{
    border-bottom:0;
  }
  .header .el-menu--popup-bottom-start{
    border-radius:0.06rem; 
    padding: 0;
    text-align: center;
  }
  .header .el-menu--popup{
    margin-left: -0.5rem;
    margin-top: -0.05rem;
  }
  .header .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
    border-bottom: 0;
  }
  .header .el-submenu__title{
    line-height: 0.78rem;
  }
  .header .el-menu--horizontal .el-menu .el-menu-item{
    padding: 0;
    height: 0.5rem;
    line-height: 0.5rem;
  }
  .header .el-menu--horizontal>.el-submenu:hover .el-submenu__title{
    color:rgba(48,48,48,1);
  }
  .header .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 0.78rem;
    line-height: 0.78rem;
  }
  .header #pay .el-dialog{
    width: 4.61rem;
    height: 6rem;
    margin: 2.79rem 0 0 7.87rem;
    border-radius:0.12rem;
  }
  .header #pay .el-dialog__header{
    padding-top: 0;
  }
  .header #pay .el-dialog__body{
    padding: 0;
  }
  .header #pay .top{
    float: left;
    width: 4.61rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center; 
    margin: 0.44rem 0 0.44rem 0;
  }
  .header #pay .top>span{
    height:0.24rem;
    font-size:0.24rem;
    line-height: 0.3rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(26,26,26,1);
  }
  .header #pay .middle{
    width: 4.61rem;
    text-align: center;
    float: left;
  }
  .header #pay .middle>div{
    width: 4.61rem;
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(26,26,26,1);
    float: left;
  }
  .header #pay .middle>div>span{
    height:0.18rem;
    font-size:0.18rem;
    font-family:SourceHanSansSC-Regular;
    font-weight:400;
    color:rgba(235,4,2,1);
  }
  .header #pay .middle>span{
    display: block;
    width: 4.61rem;
    /*background:rgba(191,191,191,1);*/
    float: left;
    margin: 0.28rem 0 0 0;
    text-align: center;
  }
  .header #pay .buttom{
    float: left;
    width: 4.61rem;
    height:0.16rem;
    margin-left: 1.84rem;
  }
  .header #pay .buttom>div{
    float: left;
    height:0.16rem;
    font-size:0.16rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(83,83,83,1);
  }
  .header #pay .buttom>div>span{
    height:0.2rem;
    font-size:0.2rem;
  }  
</style>



// WEBPACK FOOTER //
// src/components/layout/header.vue